import React from 'react';
import styled, { css } from "styled-components";
import { Star, StarFill } from 'react-bootstrap-icons';

type RatingProps = {
    rating: number;
}

const Container = styled.div`
    display:flex;
    padding-bottom:1em;
`;

const iconStyle = css`
    color: var(--main-teal-color);
    font-size:1rem;
    margin:0.03em;
`;

const StarIcon = styled(Star)`
    ${iconStyle}
`;
const FilledStarIcon = styled(StarFill)`
    ${iconStyle}
`;

function RatingView({ rating }: RatingProps) {
    const maxRating = 5;
    const CheckedStars = [];
    const UncheckedStars = [];

    for (var i = 1; i <= rating; i++) {
        CheckedStars.push(i);
    }

    for (var i = 1; i <= (maxRating - rating); i++) {
        UncheckedStars.push(i);
    }

    return (
        <Container>
            {CheckedStars.map(item =>
                <FilledStarIcon key={item} />
            )}
            {UncheckedStars.map(item =>
                <StarIcon key={item}/>
            )}
        </Container>
    );
}
export default RatingView;
